import { useEffect } from 'react'

const HangTight = ({ onNext }) => {

    useEffect(() => {
        setTimeout(() => {
          window.scrollTo(0, 0);
        }, 100);
        setTimeout(() => {
            onNext(true, true)
        }, 3000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <>
            <div className="card-hang-tight">
                <h1 className="page-title">
                    Hang Tight!
                </h1>
                <p>We’re analyzing your pool and putting together a personalized quote.</p>
                <div className="hang-tight-placholder-container">
                    <div className="hang-tight-placholder">
                        <img src="/images/blue-check.svg" alt="blue-check.svg" />
                        <div>
                            <div className="first-placeholder"></div>
                            <div className="second-placeholder"></div>
                        </div>
                    </div>
                    <div className="hang-tight-placholder">
                        <img src="/images/blue-check.svg" alt="blue-check.svg" />
                        <div>
                            <div className="first-placeholder"></div>
                            <div className="second-placeholder"></div>
                        </div>
                    </div>
                    <div className="hang-tight-placholder">
                        <img src="/images/blue-check.svg" alt="blue-check.svg" />
                        <div>
                            <div className="first-placeholder"></div>
                            <div className="second-placeholder"></div>
                        </div>
                    </div>
                    <div className="hang-tight-placholder">
                        <img src="/images/blue-check.svg" alt="blue-check.svg" />
                        <div>
                            <div className="first-placeholder"></div>
                            <div className="second-placeholder"></div>
                        </div>
                    </div>
                </div>
            </div>
            <input type="hidden" id="progress_slide_1" data-width="90%" />
        </>
    )
}

export default HangTight